import numbro from 'numbro';

export function numberFormatter<T extends string | number>(
  number?: T,
  format?: Pick<
    numbro.Format,
    'mantissa' | 'forceSign' | 'output' | 'thousandSeparated'
  >,
  fallback?: string,
) {
  try {
    if (Number.isNaN(Number(number)) || number === '') return fallback;
    const num = number === null ? numbro(0) : numbro(number);
    const val = Math.abs(num.value());
    const belowOne = val < 1;
    const belowTen = val < 10;
    const res = num.format({
      thousandSeparated: true,
      mantissa: belowOne ? 9 : belowTen ? 4 : 2,
      ...format,
    });

    return res !== 'NaN' ? res : fallback;
  } catch {
    return number;
  }
}

export function staticNumberFormatter(number: string | number) {
  try {
    let isNegative = false
    let value : any = number
    if (Number(value) < 0 ){
      value = -1 * value
      isNegative = true
    }
    const nonNumericRegex = /[^0-9]/;
    if (value && !nonNumericRegex.test(String(value))) {
      const parts = String(value)?.split('.');
      let integer = numbro(parts?.[0])?.format({thousandSeparated: true});
      let res;
      if (parts?.length > 1) {
        res = integer + '.' + parts?.[1];
      } else {
        res = integer;
      }
      return isNegative && res ? `-${res}` : res ? res : '0';
    } else {
      return '0';
    }
  } catch {
    return number;
  }
}

export function inputNumberFormatter(value: string) {
  try {
    if (value) {
      const parts = String(value)?.split('.');

      let integer = numbro(parts?.[0])?.format({thousandSeparated: true});
      let res;
      if (parts?.length > 1) {
        res = integer + '.' + parts?.[1];
      } else {
        res = integer;
      }
      return res ?? '';
    } else {
      return '';
    }
  } catch {
    return value;
  }
}

export function inputNumberFormateSetter(
  value: string,
  valueSetter: (value: string) => void,
) {
  try {
    let pureTxt = value.replaceAll(',', '');
    const regEx = new RegExp(/^[0-9]*\.?[0-9]*$/);
    var check = regEx.test(String(pureTxt));
    console.log(check, pureTxt);
    if (check || value?.length <= 1) {
      valueSetter(pureTxt);
    }
  } catch {
    return value;
  }
}
